import { FormBuilderRouteNames } from '@/routes/constants/location'
import { RouteConfig } from 'vue-router'
import { requireAuthAndLocation } from '../auth'


const FormRoot = () =>
  import('@/pmd/pages/marketing/FormRoot.vue').then(m => m.default)
const FormBuilderPage = () =>
  import(
    /* webpackChunkName: "m-form-builder" */ '@/pmd/pages/marketing/FormBuilderPage.vue'
  ).then(m => m.default)
const FormSubmissionPage = () =>
  import('@/pmd/pages/marketing/FormSubmissionPage.vue').then(m => m.default)

const EmbedBuilder = () =>
  import(
    /* webpackChunkName: "m-email-builder" */ '@/pmd/pages/marketing/EmbedBuilder.vue'
  ).then(m => m.default)

const Analytics = () =>
  import(/* webpackChunkName: "domain-settings" */ '@/pmd/pages/analytics/FunnelWebsiteAnalytics.vue').then(
    m => m.default
  )
  
export const FormBuilderRoutes: RouteConfig[] = [
  {
    path: 'form-builder',
    name: FormBuilderRouteNames.default,
    component: FormRoot,
    beforeEnter: requireAuthAndLocation,
    children: [
      {
        path: 'main',
        name: FormBuilderRouteNames.main,
        component: FormBuilderPage,
        beforeEnter: requireAuthAndLocation,
      },
      {
        path: 'analyze',
        redirect: to => {
          const query = {
            type: to.query.type || 'form',
            tab: to.query.tab || 'total_views',
          }
          return {
            path: `/v2/location/${to.params.location_id}/analytics`,
            query,
          }
        },
        name: FormBuilderRouteNames.analyze,
        component: Analytics,
        beforeEnter: requireAuthAndLocation,
      },
      {
        path: 'submissions',
        name: FormBuilderRouteNames.submissions,
        component: FormSubmissionPage,
        beforeEnter: (to, from, next) => {
          requireAuthAndLocation(to, from, () => {
            sessionStorage.removeItem('store')
            next()
          })
        },
      },
    ],
  },
  {
    path: 'form-builder/:builder_id?/integrate',
    name: FormBuilderRouteNames.integrate,
    component: EmbedBuilder,
    beforeEnter: requireAuthAndLocation,
  },
]
